module.exports = __webpack_public_path__ + "img/blueprint_2_e.15bd31fc.jpg";